<div>{{'select_text_size' | translate}}</div>
<b>{{textSize$ | async | translate}}</b>
<div class="container-text-sizes">
  @for (size of textSizes; track size; let i = $index) {
    <button
      class="list-element"
      [class.list-element--selected]="size === (textSize$ | async)"
      (click)="onClickTextSize(size)">
      <div
        class="text-size"
        [class.text-size-small]="i === 0"
        [class.text-size-medium]="i === 1"
        [class.text-size-large]="i === 2">⁺A</div>
      {{size | translate}}
  </button>
  }
</div>